import type { GetRequestReportListResponseType } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

interface UseGetIssueReportsParams {
  direction?: "asc" | "desc";
  itemsPerPage?: number;
  page?: number;
  search?: string;
  sortBy?: string;
}

export const useGetIssueReports = ({
  direction = "desc",
  itemsPerPage = 10,
  page = 1,
  search = "",
  sortBy = "createdAt",
}: UseGetIssueReportsParams) =>
  useQuery<GetRequestReportListResponseType>({
    queryFn: async () => {
      const params = new URLSearchParams({
        direction,
        itemsPerPage: itemsPerPage.toString(),
        page: page.toString(),
        sortBy,
      });

      if (search) {
        params.append("search", search);
      }

      return await apiClient
        .url(`/requests/request-reports?${params}`)
        .get()
        .json();
    },
    queryKey: ["issue-reports", page, itemsPerPage, search, sortBy, direction],
    staleTime: 30_000,
  });
